import React, { useCallback } from "react";
import { useMappedState } from "redux-react-hook";
import { Nav, NavItem, NavList } from "@patternfly/react-core";
import useReactRouter from "use-react-router";
import { Link } from "react-router-dom";
import { isAdmin } from "../../utils/userUtil";

export default () => {
  const { location } = useReactRouter();

  const mapState = useCallback(
    (state) => ({
      currentUser: state.userState.currentUser,
    }),
    []
  );

  const { currentUser } = useMappedState(mapState);

  function isActive(path) {
    const re = new RegExp("^/" + path);
    return !!location.pathname.match(re);
  }
  function renderUserNav() {
    if (isAdmin(currentUser.roles)) {
      return (
        <NavItem isActive={isActive("user")}>
          <Link to={`/user`}>User</Link>
        </NavItem>
      );
    }
  }
  function renderUsageNav() {
    if (isAdmin(currentUser.roles)) {
      return (
        <NavItem isActive={isActive("usage")}>
          <Link to={`/usage`}>Usage</Link>
        </NavItem>
      );
    }
  }

  return (
    <Nav aria-label="Nav" theme="light">
      <NavList>
        <NavItem isActive={isActive("product")}>
          <Link to={`/product/list`}>Product</Link>
        </NavItem>
        {renderUserNav()}
        <NavItem isActive={isActive("activity")}>
          <Link to={`/activity`}>Activity</Link>
        </NavItem>
        {renderUsageNav()}
      </NavList>
    </Nav>
  );
};
